<template>
  <div>
    <list
      row-key="PackageId"
      ref="list"
      unit="增值套餐设置"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="启用学校">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option
              v-for="(i,key) in schools"
              :key="key"
              :value="i.SchoolId"
              :label="i.SchoolName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select size="mini" v-model="params.Status" clearable>
            <el-option value="1" label="启用"/>
            <el-option value="0" label="禁用"/>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SchoolName" label="启用学校" min-width="150" show-overflow-tooltip />
        <el-table-column prop="BaseCharge" label="基础话费" />
        <el-table-column prop="VaCharge" label="增值费用"/>
        <el-table-column prop="TotalCharge" label="收费金额"/>
        <el-table-column prop="WaitTime" label="套餐周期" min-width="150">
          <template slot-scope="{row}">
            <span>{{row.StartMonth + ' - ' + row.EndMonth}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="RechargeMonth" label="开始开通月份" min-width="100" />
        <el-table-column prop="TotalMonth" label="周期月数" />
        <el-table-column label="收费月数">
          <template slot-scope="{row}">
            {{row.TotalMonth - row.FreeMonth - NoNum(row.NoMonths)}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="FreeMonth" label="赠送月份" /> -->
        <el-table-column prop="NoMonths" label="不收费月份" min-width="120px" />
        <el-table-column prop="GiveCharge" label="每月赠送套餐外话费" min-width="130px" />
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status==1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/consume/package").default,
      school_api: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        StartDate: "",
        EndDate: "",
        date: "",
      },
      schools: [],
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
    this.school_api.list({ Status: 1 }).then((res) => {
      if (res.Code == 0) this.schools = res.Data;
    });
  },
  methods: {
    NoNum(arr) {
      if(arr) {
        var arr2 = arr.split(",");
        return arr2.length;
      }
      return 0;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.rentMon {
  .el-form-item__content {
    width: 100%;
    text-align: center;
  }
}
</style>